/**
 * The function returns hash hex from a given hashArray buffer.
 */
const hashBufferToHex = (hashArray: number[]): string =>
    hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

export const digestValue = async (value: string): Promise<string> => {
    const msgUint8 = new TextEncoder().encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashBufferToHex(hashArray);
    return hashHex;
};

export const omitKeyValueObjectByValue = (
    keyValues: Record<string, string>,
    omitValue: string
): Record<string, string> =>
    Object.fromEntries(Object.entries(keyValues).filter(([, value]) => value !== omitValue));

export const urlRegex = (): RegExp => /^(https?:\/\/)?[\w-]+(\.[\w-]+)+[/#?]?.*$/i;

export const mailtoRegex = (): RegExp => /^mailto:[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i;

export const isExtensionUrl = (url: string | null): boolean => {
    if (!url) return false;
    const regex = /^(chrome-extension:\/\/|chrome:\/\/|edge:\/\/)/;
    return regex.test(url);
}
